import { useQuery } from '@tanstack/react-query';

import getDataQualifications from '~apis/data-qualifications/getDataQualifications';

export const USE_DATA_QUALIFICATIONS_QUERY = {
  root: ['data-qualifications'],
  default: (companyId: string) => [...USE_DATA_QUALIFICATIONS_QUERY.root, companyId],
};
export default function useDataQualificationsQuery(companyId?: string) {
  return useQuery(
    USE_DATA_QUALIFICATIONS_QUERY.default(companyId as string),
    () => getDataQualifications(companyId as string),
    {
      enabled: !!companyId,
    },
  );
}
